import { GO_TO_PLAN_ALL_CANDIDATES_GENERATION_RETRY_INTERVAL } from "@/constants/plan";
import { QueryKeys } from "@/constants/query-keys";
import { useGetAllGotoGenerationStatus } from "@/hooks/requests/go-to/use-get-all-generation-status";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback, useEffect, useRef } from "react";

interface UseCheckAllCandidateCreationProps {
  onCompleted: () => void;
}

export function useCheckAllCandidateCreation({
  onCompleted,
}: UseCheckAllCandidateCreationProps) {
  const counterRef = useRef(0);
  const timerRef = useRef<NodeJS.Timeout>();
  const queryClient = useQueryClient();
  const { allGotoCompleted, refetch } = useGetAllGotoGenerationStatus();

  useEffect(() => {
    startUpdateTimer();
    return () => {
      stopUpdateTimer();
    };
  }, []);

  useEffect(() => {
    if (allGotoCompleted) {
      stopUpdateTimer();
      queryClient.removeQueries({
        predicate: (query) =>
          query.queryKey.includes(QueryKeys.GO_TO_CANDIDATE) ||
          query.queryKey.includes(QueryKeys.GO_TO_SELECT_MEAL),
      });
      onCompleted();
    }
  }, [allGotoCompleted]);

  const startUpdateTimer = useCallback(() => {
    timerRef.current = setInterval(() => {
      if (
        counterRef.current > GO_TO_PLAN_ALL_CANDIDATES_GENERATION_RETRY_INTERVAL
      ) {
        stopUpdateTimer();
        return;
      }
      counterRef.current++;
      refetch();
    }, 2000);
  }, [refetch]);

  const stopUpdateTimer = useCallback(() => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
  }, []);
}
